export default __webpack_public_path__ + "static/media/fabrication.fc1a6edf.jpg";